import {
	GET_SINGLE_ORDER_TO_BE_RATED,
	GET_RESTAURANTS_SLIDES_URL,
	GET_SINGLE_SPOT_ORDER_TO_BE_RATED,
	GET_PROMO_SLIDER_URL
  } from "../../../../configs/index";
  import React, { useState, useEffect, useCallback } from "react";
  import ContentLoader from "react-content-loader";
  import DelayLink from "../../../helpers/delayLink";
  import Ink from "react-ink";
  import LazyLoad from "react-lazyload";
  import withRouter from "../../../../withRouter";
  import apiClient from "../../../../services/apiClient";

  import PromoSlider from "../PromoSlider";
  import { Zoom, Fade } from "react-awesome-reveal";
  import { connect } from "react-redux";
  import {
	getDeliveryRestaurants,
	getSelfpickupRestaurants,
	getSpotpickupRestaurants,
	getTableRestaurants,
  } from "../../../../services/restaurant/actions";
  
  const RestaurantList = (props) => {
	const [total, setTotal] = useState(null);
	const [restaurants, setRestaurants] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingMore, setLoadingMore] = useState(true);
	const [selfPickup, setSelfPickup] = useState(false);
	const [userPreferredSelectionDelivery, setUserPreferredSelectionDelivery] =
	  useState(true);
	const [userPreferredSelectionSelfPickup, setUserPreferredSelectionSelfPickup] =
	  useState(false);
	const [
	  userPreferredSelectionSpotPickup,
	  setUserPreferredSelectionSpotPickup,
	] = useState(false);
	const [userPreferredSelectionTables, setUserPreferredSelectionTables] =
	  useState(false);
	// Tables toggle shows by default; a deployment can hide it with enTables="false".
	const tablesEnabled = localStorage.getItem("enTables") !== "false";
	const [noRestaurants, setNoRestaurants] = useState(false);
	const [data, setData] = useState([]);
	const [reviewData, setReviewData] = useState([]);
	const [isHomeDelivery, setIsHomeDelivery] = useState(true);
  
	useEffect(() => {
	  getAllRestaurantSliders();
	//   getPromoSlides();

	  if (localStorage.getItem("enRAR") === "true" && "enRAR" === "disRAR") {
		getRatableOrdersDetails();
	  }
  
	  const userPreferredSelection = localStorage.getItem(
		"userPreferredSelection"
	  );
	  if (userPreferredSelection === "DELIVERY") {
		setUserPreferredSelectionDelivery(true);
		setIsHomeDelivery(true);
		filterDelivery();
	  } else if (
		userPreferredSelection === "SELFPICKUP" &&
		localStorage.getItem("enSPU") === "true"
	  ) {
		setUserPreferredSelectionSelfPickup(true);
		setIsHomeDelivery(true);
		filterSelfPickup();
	  } else if (
		userPreferredSelection === "SPOTPICKUP" &&
		localStorage.getItem("enSPU") === "true"
	  ) {
		setUserPreferredSelectionSelfPickup(true);
		setIsHomeDelivery(true);
		filterSpotPickup();
	  } else if (userPreferredSelection === "TABLES" && tablesEnabled) {
		  setIsHomeDelivery(false);
		  filterTables();
		} else {
		localStorage.setItem("userPreferredSelection", "DELIVERY");
		localStorage.setItem("userSelected", "DELIVERY");
		setUserPreferredSelectionDelivery(true);
		getDeliveryRestaurantsList();
	  }
	}, []);
  
	const getDeliveryRestaurantsList = () => {
	  if (localStorage.getItem("userSetAddress")) {
		setLoading(true);
		const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
		props.getDeliveryRestaurants(userSetAddress.lat, userSetAddress.lng).then((restaurants) => {
			if (restaurants && restaurants.payload.length) {
			  setTotal(restaurants.payload.length);
			  setNoRestaurants(false);
			  setLoading(false);
			  setLoadingMore(false);
			} else {
			  setTotal(null);
			  setNoRestaurants(true);
			}
		  });
	  }
	};
  
	const getSelfPickupRestaurantsList = () => {
	  if (localStorage.getItem("userSetAddress")) {
		setLoading(true);
		const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
  
		props
		  .getSelfpickupRestaurants(userSetAddress.lat, userSetAddress.lng)
		  .then((restaurants) => {
			if (restaurants && restaurants.payload.length) {
			  setTotal(restaurants.payload.length);
			  setNoRestaurants(false);
			  setLoading(false);
			  setLoadingMore(false);
			} else {
			  setTotal(null);
			  setLoading(false);
			  setLoadingMore(false);
			  setNoRestaurants(true);
			}
		  });
	  }
	};
  
	const getSpotPickupRestaurantsList = () => {
	  if (localStorage.getItem("userSetAddress")) {
		setLoading(true);
		const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
  
		props
		  .getSpotpickupRestaurants(userSetAddress.lat, userSetAddress.lng)
		  .then((restaurants) => {
			if (restaurants && restaurants.payload.length) {
			  setTotal(restaurants.payload.length);
			  setNoRestaurants(false);
			  setLoading(false);
			  setLoadingMore(false);
			} else {
			  setTotal(null);
			  setLoading(false);
			  setLoadingMore(false);
			  setNoRestaurants(true);
			}
		  });
	  }
	};
  
	const filterDelivery = () => {
	  setSelfPickup(false);
	  setRestaurants([]);
	  setUserPreferredSelectionTables(false);
	  setUserPreferredSelectionDelivery(true);
	  setUserPreferredSelectionSelfPickup(false);
	  setUserPreferredSelectionSpotPickup(false);
	  getDeliveryRestaurantsList();
	  localStorage.setItem("userPreferredSelection", "DELIVERY");
	};
  
	const filterSelfPickup = () => {
	  setSelfPickup(true);
	  setRestaurants([]);
	  setUserPreferredSelectionTables(false);
	  setUserPreferredSelectionSelfPickup(true);
	  setUserPreferredSelectionDelivery(false);
	  setUserPreferredSelectionSpotPickup(false);
	  getSelfPickupRestaurantsList();
	  localStorage.setItem("userPreferredSelection", "SELFPICKUP");
	};
  
	const filterSpotPickup = () => {
	  setSelfPickup(false);
	  setRestaurants([]);
	  setUserPreferredSelectionTables(false);
	  setUserPreferredSelectionSpotPickup(true);
	  setUserPreferredSelectionDelivery(false);
	  setUserPreferredSelectionSelfPickup(false);
	  getSpotPickupRestaurantsList();
	  localStorage.setItem("userPreferredSelection", "SELFPICKUP");
	};
  
	const getTableRestaurantsList = () => {
	  if (localStorage.getItem("userSetAddress")) {
		setLoading(true);
		const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
		props
		  .getTableRestaurants(userSetAddress.lat, userSetAddress.lng)
		  .then((restaurants) => {
			if (restaurants && restaurants.payload.length) {
			  setTotal(restaurants.payload.length);
			  setNoRestaurants(false);
			} else {
			  setTotal(null);
			  setNoRestaurants(true);
			}
			setLoading(false);
			setLoadingMore(false);
		  });
	  }
	};
  
	const filterTables = () => {
	  setSelfPickup(false);
	  setRestaurants([]);
	  setUserPreferredSelectionTables(true);
	  setUserPreferredSelectionDelivery(false);
	  setUserPreferredSelectionSelfPickup(false);
	  setUserPreferredSelectionSpotPickup(false);
	  getTableRestaurantsList();
	  localStorage.setItem("userPreferredSelection", "TABLES");
	  localStorage.setItem("userSelected", "TABLES");
	};
  
	const getAllRestaurantSliders = useCallback(() => {
	  apiClient.post(GET_RESTAURANTS_SLIDES_URL).then((response) => {
		if (response.data) {
		  setData(response.data);
		}
	  });
	}, []);

	const getPromoSlides =  async () => {
		await apiClient.post(GET_PROMO_SLIDER_URL).then((response) => {
		  if (response.data) {
			setData(response.data);
		  }
		});
	  }
  
	const changeRouteToRestaurantsCategories = (categories) => {
	  if (categories.categories_ids) {
		const saveCategorySelectOptions = new Promise((resolve) => {
		  localStorage.setItem(
			"categorySelectOptions",
			JSON.stringify(categories.categories_ids)
		  );
		  // Store parent category info for chip bar navigation
		  const parentCategory = categories.categories_ids.length > 0 ? categories.categories_ids[0] : null;
		  if (parentCategory) {
			localStorage.setItem("selectedParentCategory", JSON.stringify(parentCategory));
		  }
		  resolve("categorySelectOptions Saved");
		});
		saveCategorySelectOptions.then(() => {
		  props.navigate("categories/stores");
		});
	  }
	};
  
	const getRatableOrdersDetails = () => {
	  const { user } = props;
	  if (user.success) {
		apiClient
		  .post(GET_SINGLE_ORDER_TO_BE_RATED, {
			user_id: user.data.id,
			token: user.data.auth_token,
		  })
		  .then((response) => {
			setReviewData(response.data);
		  });
	  }
	};
  
	const getRatableSpotOrdersDetails = () => {
	  const { user } = props;
	  if (user.success) {
		apiClient
		  .post(GET_SINGLE_SPOT_ORDER_TO_BE_RATED, {
			user_id: user.data.id,
			token: user.data.auth_token,
		  })
		  .then((response) => {
			setReviewData(response.data);
		  });
	  }
	};
  
	const animateStarIcon = () => {
	  let stars = [];
  
	  for (let i = 1; i <= 5; i++) {
		stars.push(
		  <Zoom direction="up" delay={i * 100} key={i}>
			<i
			  className="fa fa-star pr-1"
			  style={{ color: localStorage.getItem("rarModHomeBannerStarsColor") }}
			/>
		  </Zoom>
		);
	  }
	  return stars;
	};
  
	return (
	  <React.Fragment>
		<div className="bg-white mb-100">
		  {noRestaurants && (
			<div
			  className={
				"bg-light " + (localStorage.getItem("enSPU") === "true" ? "sticky-top" : "pt-3")
			  }
			>
			  {(localStorage.getItem("enSPU") === "true" || tablesEnabled) ? (
				<React.Fragment>
				  <div className="px-15 py-3 d-flex justify-content-between align-items-center">
					<h1 className="restaurant-count mb-0 mr-2">
					  {localStorage.getItem("noRestaurantMessage")}
					</h1>
					<div className="d-flex">
					  <button
						onClick={filterDelivery}
						className={
						  "btn btn-preference mr-2 " +
						  (userPreferredSelectionDelivery ? "user-preferred" : "")
						}
					  >
						{localStorage.getItem("deliveryTypeDelivery")}
						{userPreferredSelectionDelivery && (
						  <i className="si si-check ml-2" />
						)}
					  </button>
					  {localStorage.getItem("enSPU") === "true" && (
					  <button
						onClick={filterSelfPickup}
						className={
						  "btn btn-preference " +
						  (userPreferredSelectionSelfPickup ? "user-preferred" : "")
						}
					  >
						{localStorage.getItem("deliveryTypeSelfPickup")}
						{userPreferredSelectionSelfPickup && (
						  <i className="si si-check ml-2" />
						)}
					  </button>
					  )}
					  {tablesEnabled && (
					    <button
					  	onClick={filterTables}
					  	className={
					  	  "btn btn-preference ml-2 " +
					  	  (userPreferredSelectionTables ? "user-preferred" : "")
					  	}
					    >
					  	{localStorage.getItem("homeModeTables") || "Tables"}
					  	{userPreferredSelectionTables && (
					  	  <i className="si si-check ml-2" />
					  	)}
					    </button>
					  )}
					</div>
				  </div>
				  <hr />
				</React.Fragment>
			  ) : (
				<h1 className="restaurant-count mb-0 mr-2 px-15">
				  {localStorage.getItem("noRestaurantMessage")}
				</h1>
			  )}
			  <hr />
			</div>
		  )}
		  {total ? (
			<React.Fragment>
			  <div
				className={
				  "bg-light " + (localStorage.getItem("enSPU") === "true" ? "sticky-top" : "pt-3")
				}
			  >
				{(localStorage.getItem("enSPU") === "true" || tablesEnabled) && (
				  <React.Fragment>
					<div className="px-15 py-3 d-flex justify-content-between align-items-center">
					  <h1 className="restaurant-count mb-0 mr-2">
						{!loading && total} {localStorage.getItem("restaurantCountText")}
					  </h1>
  
					  <div className="d-flex">
						<button
						  onClick={filterDelivery}
						  className={
							"btn btn-preference mr-2 " +
							(userPreferredSelectionDelivery ? "user-preferred" : "")
						  }
						>
						  {localStorage.getItem("deliveryTypeDelivery")}
						  {userPreferredSelectionDelivery && (
							<i className="si si-check ml-2" />
						  )}
						</button>
						{localStorage.getItem("enSPU") === "true" && (
						<button
						  onClick={filterSelfPickup}
						  className={
							"btn btn-preference " +
							(userPreferredSelectionSelfPickup ? "user-preferred" : "")
						  }
						>
						  {localStorage.getItem("deliveryTypeSelfPickup")}
						  {userPreferredSelectionSelfPickup && (
							<i className="si si-check ml-2" />
						  )}
						</button>
						)}
						{tablesEnabled && (
						  <button
							onClick={filterTables}
							className={
							  "btn btn-preference ml-2 " +
							  (userPreferredSelectionTables ? "user-preferred" : "")
							}
						  >
							{localStorage.getItem("homeModeTables") || "Tables"}
							{userPreferredSelectionTables && (
							  <i className="si si-check ml-2" />
							)}
						  </button>
						)}
					  </div>
					</div>
				  </React.Fragment>
				)}
			  </div>
			</React.Fragment>
		  ) : null}
  
		  {localStorage.getItem("restaurantCategorySliderPosition") === "0" && (
			<React.Fragment>
			  {data.length > 0 && (
				<div className="slider-wrapper secondary-slider-wrapper my-0 pb-20">
				  {data.map((category) => (
					<div className="slider-wrapper__img-wrapper" key={category.id}>
					  <div
						style={{ position: "relative" }}
						onClick={() => {
						  changeRouteToRestaurantsCategories(category);
						}}
					  >
						<img
						  src={category.image}
						  alt={category.name}
						  className="slider-wrapper__img slider-cust-img"
						  style={{
							height:
							  (9 / 5) *
							  parseInt(localStorage.getItem("restaurantCategorySliderSize")) +
							  "rem",
							width:
							  (13.5 / 5) *
							  parseInt(localStorage.getItem("restaurantCategorySliderSize")) +
							  "rem",
							borderRadius:
							  parseFloat(localStorage.getItem("restaurantCategorySliderStyle")) +
							  "rem",
						  }}
						/>
						{localStorage.getItem("showRestaurantCategorySliderLabel") === "true" && (
						  <span className="category-slider-name">{category.name}</span>
						)}
						<Ink duration="500" hasTouch={true} />
					  </div>
					</div>
				  ))}
				</div>
			  )}
			</React.Fragment>
		  )}
		  {loading ? (
			<ContentLoader
			  height={378}
			  width={400}
			  speed={1.2}
			  primarycolor="#f3f3f3"
			  secondarycolor="#ecebeb"
			>
			  <rect x="20" y="20" rx="4" ry="4" width="80" height="78" />
			  <rect x="144" y="30" rx="0" ry="0" width="115" height="18" />
			  <rect x="144" y="60" rx="0" ry="0" width="165" height="16" />
  
			  <rect x="20" y="145" rx="4" ry="4" width="80" height="78" />
			  <rect x="144" y="155" rx="0" ry="0" width="115" height="18" />
			  <rect x="144" y="185" rx="0" ry="0" width="165" height="16" />
  
			  <rect x="20" y="270" rx="4" ry="4" width="80" height="78" />
			  <rect x="144" y="280" rx="0" ry="0" width="115" height="18" />
			  <rect x="144" y="310" rx="0" ry="0" width="165" height="16" />
			</ContentLoader>
		  ) : (
			<React.Fragment>
			  {props.restaurants.length === 0 ? (
				<ContentLoader
				  height={378}
				  width={400}
				  speed={1.2}
				  primarycolor="#f3f3f3"
				  secondarycolor="#ecebeb"
				>
				  <rect x="20" y="20" rx="4" ry="4" width="80" height="78" />
				  <rect x="144" y="30" rx="0" ry="0" width="115" height="18" />
				  <rect x="144" y="60" rx="0" ry="0" width="165" height="16" />
  
				  <rect x="20" y="145" rx="4" ry="4" width="80" height="78" />
				  <rect x="144" y="155" rx="0" ry="0" width="115" height="18" />
				  <rect x="144" y="185" rx="0" ry="0" width="165" height="16" />
  
				  <rect x="20" y="270" rx="4" ry="4" width="80" height="78" />
				  <rect x="144" y="280" rx="0" ry="0" width="115" height="18" />
				  <rect x="144" y="310" rx="0" ry="0" width="165" height="16" />
				</ContentLoader>
			  ) : (
				props.restaurants.map((restaurant, index) => (
				  <React.Fragment key={restaurant.id}>
					<LazyLoad>
					  <div className="col-xs-12 col-sm-12 restaurant-block">
						<DelayLink
						  to={userPreferredSelectionTables ? ("/book-table/" + restaurant.id) : ("../stores/" + restaurant.slug)}
						  delay={200}
						  className="block text-center mb-3"
						  clickAction={() => {
							localStorage.getItem("userPreferredSelection") ===
							  "DELIVERY" &&
							  restaurant.delivery_type === 1 &&
							  localStorage.setItem("userSelected", "DELIVERY");
							localStorage.getItem("userPreferredSelection") ===
							  "SELFPICKUP" &&
							  restaurant.delivery_type === 2 &&
							  localStorage.setItem("userSelected", "SELFPICKUP");
							localStorage.getItem("userPreferredSelection") ===
							  "DELIVERY" &&
							  restaurant.delivery_type === 3 &&
							  localStorage.setItem("userSelected", "DELIVERY");
							localStorage.getItem("userPreferredSelection") ===
							  "SELFPICKUP" &&
							  restaurant.delivery_type === 3 &&
							  localStorage.setItem("userSelected", "SELFPICKUP");
						  }}
						>
						  <div
							className={`block-content block-content-full ${
							  restaurant.is_featured && restaurant.is_active
								? "ribbon ribbon-bookmark ribbon-warning pt-2"
								: "pt-2"
							} `}
						  >
							{restaurant.is_featured ? (
								<React.Fragment>
									{restaurant.custom_featured_name == null ? (
										<div className="ribbon-box">
											{localStorage.getItem("restaurantFeaturedText")}
										</div>
									) : (
										<div className="ribbon-box">
											{restaurant.custom_featured_name}
										</div>
									)}
								</React.Fragment>
							) : null}
  
							<Fade duration={500}>
							  <img
								src={restaurant.image}
								alt={restaurant.name}
								className={`restaurant-image ${
								  !restaurant.is_active && "restaurant-not-active"
								}`}
							  />
							</Fade>
						  </div>
						  <div className="block-content block-content-full restaurant-info">
							<div className="font-w600 mb-5 text-dark">
							  {restaurant.name}
							</div>
							<div className="font-size-sm text-muted truncate-text text-muted">
							  {restaurant.description}
							</div>
							{!restaurant.is_active && (
							  <span className="restaurant-not-active-msg">
								{localStorage.getItem("restaurantNotActiveMsg")}
							  </span>
							)}
							<hr className="my-10" />
							<div className="text-center restaurant-meta mt-5 d-flex align-items-center justify-content-between text-muted">
							  <div className="col-2 p-0 text-left">
								<i
								  className={`fa fa-star pr-1 ${
									!restaurant.is_active &&
									"restaurant-not-active"
								  }`}
								  style={{
									color: localStorage.getItem("storeColor"),
								  }}
								/>{" "}
								{restaurant.avgRating === "0"
								  ? restaurant.rating
								  : restaurant.avgRating}
							  </div>
							  <div className="col-4 p-0 text-center">
								{selfPickup ? (
								  <span>
									<i className="si si-pointer pr-1" />
									{restaurant.distance &&
									  restaurant.distance.toFixed(1)}{" "}
									Km
								  </span>
								) : (
								  <span>
									<i className="si si-clock pr-1" />{" "}
									{restaurant.delivery_time}{" "}
									{localStorage.getItem("homePageMinsText")}
								  </span>
								)}
							  </div>
							  <div className="col-6 p-0 text-center">
								<i className="si si-wallet" />{" "}
								{localStorage.getItem("currencySymbolAlign") ===
								  "left" && (
								  <React.Fragment>
									{localStorage.getItem("currencyFormat")}
									{restaurant.price_range}{" "}
								  </React.Fragment>
								)}
								{localStorage.getItem("currencySymbolAlign") ===
								  "right" && (
								  <React.Fragment>
									{restaurant.price_range}
									{localStorage.getItem("currencyFormat")}{" "}
								  </React.Fragment>
								)}
								{localStorage.getItem("homePageForTwoText")}
							  </div>
							</div>
						  </div>
						  <Ink duration="500" hasTouch={false} />
						</DelayLink>
					  </div>
					</LazyLoad>
					{localStorage.getItem("showPromoSlider") === "true" && (
					  <React.Fragment>
						{props.slides && props.slides.length > 0 && (
						  <React.Fragment>
							{index ===
							  props.slides[0]["promo_slider"]["position_id"] - 1 && (
							  <PromoSlider
								slides={props.slides}
								size={props.slides[0]["promo_slider"]["size"]}
								secondarySlider={true}
							  />
							)}
						  </React.Fragment>
						)}
					  </React.Fragment>
					)}
					{localStorage.getItem("enRestaurantCategorySlider") ===
					  "true" && (
					  <React.Fragment>
						{index ===
						  parseInt(
							localStorage.getItem("restaurantCategorySliderPosition")
						  ) - 1 && (
						  <React.Fragment>
							{data.length > 0 && (
							  <div className="slider-wrapper secondary-slider-wrapper my-20">
								{data.map((category) => (
								  <div
									className="slider-wrapper__img-wrapper"
									key={category.id}
								  >
									<div
									  style={{ position: "relative" }}
									  onClick={() => {
										changeRouteToRestaurantsCategories(
										  category
										);
									  }}
									>
									  <img
										src={category.image}
										alt={category.name}
										className="slider-wrapper__img slider-cust-img"
										style={{
										  height:
											(9 / 5) *
											parseInt(
											  localStorage.getItem(
												"restaurantCategorySliderSize"
											  )
											) +
											"rem",
										  width:
											(13.5 / 5) *
											parseInt(
											  localStorage.getItem(
												"restaurantCategorySliderSize"
											  )
											) +
											"rem",
										  borderRadius:
											parseFloat(
											  localStorage.getItem(
												"restaurantCategorySliderStyle"
											  )
											) + "rem",
										}}
									  />
									  {localStorage.getItem(
										"showRestaurantCategorySliderLabel"
									  ) === "true" && (
										<span className="category-slider-name">
										  {category.name}
										</span>
									  )}
									  <Ink duration="500" hasTouch={true} />
									</div>
								  </div>
								))}
							  </div>
							)}
						  </React.Fragment>
						)}
					  </React.Fragment>
					)}
					{reviewData.ratable &&
					  localStorage.getItem("enRAR") === "true" &&
					  localStorage.getItem("rarModEnHomeBanner") === "true" &&
					  "enRAR" === "disRAR" && (
						<React.Fragment>
						  {console.log("Came here")}
						  {!loading &&
							index ===
							  parseInt(
								localStorage.getItem("rarModHomeBannerPosition")
							  ) -
								1 && (
							  <div
								className="col-xs-12 col-sm-12 rating-block px-15 py-10"
								style={{
								  backgroundColor: localStorage.getItem(
									"rarModHomeBannerBgColor"
								  ),
								}}
							  >
								<DelayLink
								  to={{
									pathname:
									  "../rate-and-review/" +
									  reviewData.data.id,
								  }}
								  delay={250}
								>
								  <div className="d-flex justify-content-between align-items-center">
									<strong
									  style={{
										color: localStorage.getItem(
										  "rarModHomeBannerTextColor"
										),
									  }}
									>
									  {localStorage.getItem(
										"rarModHomeBannerText"
									  )}
									  {localStorage.getItem(
										"rarModShowBannerRestaurantName"
									  ) === "true" &&
										reviewData.data.restaurant.name}
									</strong>
									<span
									  className="btn btn-default"
									  style={{
										minWidth: "100px",
										textAlign: "center",
									  }}
									>
									  {animateStarIcon()}
									</span>
								  </div>
								  <Ink duration="500" hasTouch={false} />
								</DelayLink>
							  </div>
							)}
						</React.Fragment>
					  )}
				  </React.Fragment>
				))
			  )}
			</React.Fragment>
		  )}
  
		  {loadingMore ? (
			<div className="">
			  <ContentLoader
				height={120}
				width={400}
				speed={1.2}
				primarycolor="#f3f3f3"
				secondarycolor="#ecebeb"
			  >
				<rect x="20" y="20" rx="4" ry="4" width="80" height="78" />
				<rect x="144" y="35" rx="0" ry="0" width="115" height="18" />
				<rect x="144" y="65" rx="0" ry="0" width="165" height="16" />
			  </ContentLoader>
			</div>
		  ) : null}
		</div>
	  </React.Fragment>
	);
  };
  
  const mapStateToProps = (state) => ({
	restaurants: state.restaurant.restaurants,
  });
  
  export default withRouter(
	connect(mapStateToProps, {
	  getDeliveryRestaurants,
	  getSelfpickupRestaurants,
	  getSpotpickupRestaurants,
	  getTableRestaurants,
	})(RestaurantList)
  );
  